module.exports = __webpack_public_path__ + "static/media/briefcase.02b3c3c6.svg";